import { render } from "./SzTree.vue?vue&type=template&id=236a5cfc&scoped=true"
import script from "./SzTree.vue?vue&type=script&lang=ts"
export * from "./SzTree.vue?vue&type=script&lang=ts"

import "./SzTree.vue?vue&type=style&index=0&id=236a5cfc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-236a5cfc"

export default script